export default "__VITE_ASSET__CdrBCFd2__"